import styled from 'styled-components';

import { Form } from '~/components/Form';

export const Wrapper = styled(Form)`
  width: 100%;
  flex-grow: 1;

  header {
    width: 100% !important;
    margin: 0 !important;
  }
`;
